import React, { ComponentProps } from "react";
import { Icon } from "../icon";
import { TransparentButton } from "../transparent-button";

/** Cancel button used in ConfirmationBar */
export const ConfirmationBarCancelButton = (props: ComponentProps<typeof TransparentButton>) => (
	<TransparentButton {...props}>
		<Icon iconName="cross" />
	</TransparentButton>
);
